import { patientAction } from '../../actions/constant';

const {
  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_FAILURE,
  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_SUCCESS,
  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_LOADING,
} = patientAction;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
  loading: false,
};

export const getDownloadCSVTemplateReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_LOADING:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
